var map = {
	"./login/login.module.ngfactory": [
		138,
		4
	],
	"./meals/meals.module.ngfactory": [
		141,
		2
	],
	"./register/register.module.ngfactory": [
		139,
		3
	],
	"./schedule/schedule.module.ngfactory": [
		140,
		0
	],
	"./workouts/workouts.module.ngfactory": [
		142,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 54;


//////////////////
// WEBPACK FOOTER
// ./ngfactory lazy
// module id = 54
// module chunks = 5